import { toString, MEMBER_BASE_PATH, PROFILE_BASE_PATH } from '@core/links/members';

export const toProfileUrlTemplate = (subPath: string) =>
  subPath.indexOf('[memberId]') > -1
    ? toString({ basePath: MEMBER_BASE_PATH, subPath })
    : toString({ basePath: PROFILE_BASE_PATH, subPath });
